import React from 'react';

import { Title, Spinner } from 'common/components';
import { Filter } from 'common/containers';
import { Glossary, PlanListGL } from 'common/utils/glossary';
import { Plan } from './Plan';
import { default as PlanListMessage } from '../containers/PlanListMessage';
import { default as AllPlanDispLink } from '../containers/AllPlanDispLink';

interface PlanListsProps {
  /** プランのリスト */
  plans: {
    imageSrc: string;
    planId: string;
    planName: string;
    planDescription: string;
    payment: string;
    onClickDetail: () => void;
    onClickPurchase: () => void;
  }[];
  /** プラン一覧画面の初期化処理 */
  initializePage: () => void;
  /** 未ログイン状態で購入ボタンを押下し、ログイン後に購入確認画面を表示する */
  checkBeforePurchaseInfo: (
    planId: string,
    planName: string,
    payment: string
  ) => void;
  /** checkBeforePurchaseInfoの後処理 */
  deleteBeforePurchaseInfo: () => void;
  /** 国地域が選択済みか否か */
  isSelectedCountry: boolean;
  /** 選択している国地域、言語、serviceId */
  select: {
    country: string;
    language: string;
    serviceId: string;
  };
  /** グロッサリ */
  glossary: Glossary;
  /** プラン取得処理中か否か */
  isProcessingList: boolean;
  /** 購入開始処理中のプランID */
  processingPlanId: string;
}

/**
 * プランリストのPresentation Component
 */
export const PlanLists: React.FC<PlanListsProps> = ({
  plans,
  initializePage,
  checkBeforePurchaseInfo,
  deleteBeforePurchaseInfo,
  isSelectedCountry,
  glossary,
  isProcessingList,
  processingPlanId
}) => {
  // 初期化処理のイベント
  React.useEffect(() => {
    isSelectedCountry && initializePage();
  }, [isSelectedCountry]);

  // リスト部に表示するComponentをメモライズ
  const listComponent = React.useMemo(() => {
    const components = plans.map(function (plan) {
      checkBeforePurchaseInfo(plan.planId, plan.planName, plan.payment);
      // 購入開始処理中かつ実行中のプランか判定フラグ
      const isProcessingPurchase = processingPlanId == plan.planId;
      return (
        <Plan
          {...plan}
          isProcessingPurchase={isProcessingPurchase}
          glossary={glossary}
          data-test={plan.planId}
          key={`${plan.planId}`}
        />
      );
    });
    deleteBeforePurchaseInfo();
    return components;
  }, [plans, isSelectedCountry, processingPlanId]);

  return (
    <div className="list" data-test="planLists">
      <Title type="heading" data-test="planListsHead">
        {glossary.glx(PlanListGL.ListTitle)}
        <Filter />
      </Title>
      <PlanListMessage />
      <AllPlanDispLink />
      {listComponent}
      {isProcessingList ? <Spinner /> : null}
    </div>
  );
};
